import Card from "./Card";
import { openMailTo } from "../../../../utils/Common/contact";
import Button from "Components/Common/Button/Button";

interface Contact {
  name: string;
  role: string;
  initials: string;
  avatarVariant: string;
  action: string;
  secondText?: string;
}

interface ContactsCardProps {
  contacts: Contact[];
  infoNote?: string | React.ReactNode;
  onMessage?: () => void;
}

const ContactsCard = ({ contacts, infoNote, onMessage }: ContactsCardProps) => {
  return (
    <Card title="Key Contacts">
      {contacts.map((contact) => (
        <div className="contactItem" key={contact.name}>
          <div className={`contactAv ${contact.avatarVariant}`}>
            {contact.initials}
          </div>
          <div className="contactInfo">
            <div className="contactName">{contact.name}</div>
            <div className="contactRole">
              {contact.role} · {contact.secondText}
            </div>
          </div>
          {contact.action === "message" ? (
            <Button type="button" className="contactAction" onClick={onMessage}>
              Message →
            </Button>
          ) : (
            <Button
              type="button"
              className="contactAction"
              onClick={() => openMailTo(contact.action)}
            >
              Email →
            </Button>
          )}
        </div>
      ))}
      {infoNote ? <div className="infoBox">{infoNote}</div> : null}
    </Card>
  );
};

export default ContactsCard;
